import { TableColumn } from "../table/TableColumn";

const DiscoveryColumns: TableColumn[] = [
    {
        heading: "Address",
        accessor: "address",
        isNumeric: false,
        id: 0,
        sortByName: "address",
        sortDirection: "asc",
        active: false,
        translationKey: "address"
    },
    {
        heading: "Serial",
        accessor: "serialAddress",
        isNumeric: false,
        id: 1,
        sortByName: "serialAddress",
        sortDirection: "asc",
        active: true,
        translationKey: "serial"
    },
    {
        heading: "IP Address",
        accessor: "ipAddress",
        isNumeric: false,
        id: 2,
        sortByName: "ipAddress",
        sortDirection: "asc",
        active: true,
        translationKey: "ip"
    },
    {
        heading: "Version",
        accessor: "version",
        isNumeric: false,
        id: 3,
        sortByName: "version",
        sortDirection: "asc",
        active: true,
        translationKey: "version"
    },
    {
        heading: "Model",
        accessor: "baseDeviceName",
        isNumeric: false,
        id: 4,
        sortByName: "baseDeviceName",
        sortDirection: "asc",
        active: true,
        translationKey: "baseDeviceName"
    }
]

export default DiscoveryColumns;


